// Angular
import { Component, OnInit } from "@angular/core";
import { RouteConfigLoadStart, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
// Models
import { DatePipe } from "@angular/common";

import { Attachment } from "./../../models/attachment";
import { Club, Course, Tee } from "./../../models/club";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import * as lodash from "lodash";
import { AmazingTimePickerService } from "amazing-time-picker"; // this line you need

import { ApiService } from "../../services/api";
import { FormsService } from "./../../services/forms";
import { OAuthService } from "app/services/o-auth";
import { Subscription } from "rxjs";
import { delay } from "rxjs/operator/delay";
import { environment } from "environments/environment";

@Component({
  templateUrl: "./add.tournament.component.html",
})
export class AddTournamentNewComponent implements OnInit {
  public loading: boolean;
  public form: FormGroup;
  public minEndDate: Date;
  public club: any;
  public course: Course;
  public courses: Array<Course>;
  public tees: Array<Tee>;
  public holesPart: Array<{ value: number; name: string }>;
  public tournament: any;
  public startTime: Array<any>;
  public say_hello = "Hello world";

  private attachment: Attachment;
  private attachmentExt: string;
  private orginalAttachment: Attachment;
  public enterPlayerPlaceholder = "Enter no. of players";
  public minFrom: any;
  public minTill: any;
  public modes: Array<any>;
  public user: any;
  public ownerList: Array<any> = [];
  public events: Array<any> = [];
  submit1() {}
  constructor(
    private router: Router,
    private firebase: FirebaseApp,
    private datePipe: DatePipe,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    public formsService: FormsService,
    private oAuthService: OAuthService,
    private atp: AmazingTimePickerService
  ) {
    const date = new Date();
    var hour = "";
    if (date.getHours() < 10) {
      hour = "0" + date.getHours();
    } else {
      hour = date.getHours() + "";
    }
    var minutes = "";
    if (date.getMinutes() < 10) {
      minutes = "0" + date.getMinutes();
    } else {
      minutes = date.getMinutes() + "";
    }
    this.user = this.oAuthService.getClub();

    this.form = new FormGroup({
      eventName: new FormControl("", Validators.required),
      startDate: new FormControl(new Date(), Validators.required),
      // entriesEndDate: new FormControl(new Date(), Validators.required),
      endDate: new FormControl(`${23}:${59}`),
      info: new FormControl(""),
      image: new FormControl(""),
      uid: new FormControl(this.user.uid),
      cid: new FormControl("", Validators.required),
      course: new FormControl("", Validators.required),
      tee: new FormControl("", Validators.required),
      originalImage: new FormControl(""),
      organizerType: new FormControl(""),
      type: new FormControl(-1, Validators.required),
      holesPart: new FormControl("", Validators.required),
      holesCount: new FormControl("", Validators.required),
      teamPlay: new FormControl(0),
      proAm: new FormControl(false),
      scoreTeamPlay: new FormControl(0),
      isClosed: new FormControl("false"),
      noOfEnteries: new FormControl("", Validators.required),
      team: new FormControl(0),
      playerPerTeam: new FormControl(0),
      proGameType: new FormControl(0),
      handicap_percentage: new FormControl(100),
      startTime: new FormControl(`${hour}:${minutes}`),
      isShowOnWebsite: new FormControl(true),
      isLast3ScoreHide: new FormControl(false),
      isUnlimitedPlayers: new FormControl(false),
      mapWithEvent: new FormControl(false),
      offerId: new FormControl(undefined, Validators.required),
      offerOwnerId: new FormControl(),
      slop_rating: new FormControl("113", Validators.required),
    });
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    this.tournament = {
      eventName: "",
      handicap_percentage: 1,
      startDate: new Date().getTime() / 1000,
      // entriesEndDate: new Date().getTime() / 1000,
      endDate: end.getTime() / 1000,
      noOfEnteries: "",
      playerPerTeam: 1,
      proGameType: 0,
      team: "",
      info: "",
      image: "",
      cid: "",
      course: "",
      userId: this.user.uid,
      uid: this.user.cid,
      tee: "",
      type: "",
      holesPart: "",
      scoreTeamPlay: 1,
      holesCount: "",
      teamPlay: "",
      originalImage: "",
      proAm: false,
      isLast3ScoreHide: false,
      isClosed: "true",
    };
    this.modes = [];
    this.modes.push(
      { value: 0, name: "Best 1 score", selectable: false },
      { value: 2, name: "Best 2 scores", selectable: false },
      { value: 3, name: "Best 3 scores", selectable: false },
      { value: 4, name: "Best 4 scores", selectable: false },
      { value: 5, name: "Alternate Pairs ", selectable: true },
      { value: 6, name: "Scramble ", selectable: true }
    );
    this.minTill = new Date();
    this.minFrom = new Date();
    this.minEndDate = moment().toDate();

    this.form.controls["teamPlay"].valueChanges.subscribe((value) => {
      if (value === 0) {
        this.form.controls["proAm"].reset(false);
      }
    });

    this.form.controls["team"].valueChanges.subscribe((team) => {
      if (team) {
        this.enterPlayerPlaceholder = "Enter no. of teams";
      } else {
        this.enterPlayerPlaceholder = "Enter no. of players";
      }
      if (team == 2) {
        this.form.controls["proAm"].setValue(true);
      }
    });

    this.form.controls["course"].valueChanges.subscribe((course) => {
      this.tees = [];
      this.holesPart = [];
      this.form.controls["tee"].reset("");
      this.form.controls["holesPart"].reset("");

      if (!course) {
        return;
      }

      this.course = this.club.courses[course];
      console.log("this.club", this.club);
      lodash.forEach(this.course.tees, (tee, key) => {
        this.tees.push(lodash.assign(tee, { $key: key }));
      });

      this.form.controls["holesCount"].patchValue(this.course.holes);

      this.holesPart = [{ value: 1, name: "All 9" }];

      if (this.course.holes === 18) {
        this.holesPart = [
          { value: 0, name: "All 18" },
          { value: 1, name: "Front 9" },
          { value: 2, name: "Back 9" },
        ];
      }
    });
    this.minTill = new Date();
    this.minFrom = new Date();
    this.minEndDate = moment().toDate();

    this.form.get("startDate").valueChanges.subscribe((val) => {
      this.tournament.startDate = this.datePipe.transform(val, "yyyy-MM-dd");
      this.minTill = val;
    });

    // this.form.get("entriesEndDate").valueChanges.subscribe((val) => {
    //   this.tournament.entriesEndDate = this.datePipe.transform(val, "yyyy-MM-dd");
    // });

    this.form.get("playerPerTeam").valueChanges.subscribe((event) => {
      this.modes = [];
      if (event === 4) {
        this.form.controls["teamPlay"].patchValue(4);

        this.modes.push(
          { value: 1, name: "Best 1 score", selectable: false },
          { value: 2, name: "Best 2 scores", selectable: false },
          { value: 3, name: "Best 3 scores", selectable: false },
          { value: 4, name: "Best 4 scores", selectable: false },
          { value: 5, name: "Alternate Pairs ", selectable: true },
          { value: 6, name: "Scramble ", selectable: true }
        );
      }
      if (event === 3) {
        this.form.controls["teamPlay"].patchValue(3);
        this.modes.push(
          { value: 1, name: "Best 1 score", selectable: false },
          { value: 2, name: "Best 2 scores", selectable: false },
          { value: 3, name: "Best 3 scores", selectable: false },
          { value: 5, name: "Alternate Pairs ", selectable: true },
          { value: 6, name: "Scramble ", selectable: true }
        );
      }
      if (event === 2) {
        this.form.controls["teamPlay"].patchValue(2);
        this.modes.push(
          { value: 1, name: "Best 1 score", selectable: false },
          { value: 2, name: "Best 2 scores", selectable: false },
          { value: 5, name: "Alternate Pairs ", selectable: true },
          { value: 6, name: "Scramble ", selectable: true }
        );
      }
      this.form.controls["scoreTeamPlay"].patchValue(1);
    });

    this.form.get("team").valueChanges.subscribe((val) => {
      if (val === "true") {
      } else {
        this.form.controls["playerPerTeam"].patchValue(0);
        this.form.controls["teamPlay"].patchValue(0);
      }
    });
    this.form.controls["offerId"].disable();
    this.form.get("mapWithEvent").valueChanges.subscribe((val) => {
      if (!val) {
        this.form.controls["offerId"].disable();
        this.form.controls["offerId"].reset();
      } else {
        this.form.controls["offerId"].enable();
      }
    });
    //this.startTime = this.timelineLabels("00:30", 30, "m");
    //this.startTime = lodash.unionBy(this.startTime);
    if (this.user.type == 1) this.changeClub(this.user);
  }

  async ngOnInit() {
   await this.getDefaultList();
    setTimeout(() => {
      console.log('waited for eventlist');
      console.log("eventlist: ", this.events)
    }, 10000);    

  }
  
  timelineLabels(desiredStartTime, interval, period) {
    const periodsInADay = moment.duration(1, "day").as(period);

    const timeLabels = [];
    const startTimeMoment = moment(desiredStartTime, "hh:mm");
    for (let i = 0; i <= periodsInADay; i += interval) {
      startTimeMoment.add(i === 0 ? 0 : interval, period);
      // console.log(startTimeMoment.hour(), startTimeMoment.minute());
      if (!(startTimeMoment.hour() == 0 && startTimeMoment.minute() == 0))
        timeLabels.push(startTimeMoment.format("hh:mm"));
    }

    return timeLabels;
  }
  changeAttachment(attachment: Attachment): void {
    console.log(attachment.width, attachment.height);

    if (attachment) {
      if (attachment.isOriginal) {
        this.orginalAttachment = attachment;
      } else {
        this.attachment = attachment;
      }
      this.attachmentExt = attachment.file.name.split(".").pop();

      this.form.controls["image"].patchValue(this.attachmentExt);
    } else {
      this.attachmentExt = "";
    }
  }

  changeStartDate(date: number) {
    this.tournament.startDate = date;
    this.form.controls["startDate"].patchValue(date);
  }

  changeEndDate(date: number) {
    this.tournament.endDate = date;

    this.form.controls["endDate"].patchValue(date);
  }

  changeClub(club: any) {
    // console.log(club)
    this.tees = [];
    this.courses = [];
    this.holesPart = [];
    this.form.controls["cid"].reset("");
    this.form.controls["tee"].reset("");
    this.form.controls["course"].reset("");
    this.form.controls["holesPart"].reset("");

    if (!club) {
      return;
    }
    this.club = club;
    let cid = this.club.cid ? this.club.cid : this.club.$key;
    this.form.controls["cid"].setValue(cid);
    lodash.forEach(club.courses, (course, key) => {
      this.courses.push(lodash.assign(course, { $key: key }));
    });
  }

  private uploadFile(): Promise<any> {
    var newImage = new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/tournamets/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve(1);
      }
    });
    var OriginalImage = new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/tournamets/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.orginalAttachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve(1);
      }
    });
    return Promise.all([newImage, OriginalImage]);
  }

  public submit(): void {
    // console.log(this.form);
    if (this.form.value.mapWithEvent == true && !this.form.value.offerId) {
      return;
    }
    if (this.form.value.type == 2 && !this.form.value.organizerType)
    { 
      alert('Please select Organizer Type')
      return
    }

    this.loading = true;
    this.tournament.mapWithEvent = this.form.value.mapWithEvent ? 1 : 2;
    if (this.tournament.mapWithEvent == 1 && this.form.value.offerId) {
      this.tournament.offerId = this.form.value.offerId;
      this.tournament.offerOwnerId = this.user.cid;
    }
    this.tournament.eventName = this.form.value["eventName"];
    this.tournament.info = this.form.value["info"];
    this.tournament.image = this.form.value["image"];
    this.tournament.cid = this.form.value["cid"];
    this.tournament.course = this.form.value["course"];
    this.tournament.tee = this.form.value["tee"];
    this.tournament.type = parseInt(this.form.value["type"]);
    this.tournament.holesPart = parseInt(this.form.value["holesPart"]);
    this.tournament.holesCount = parseInt(this.form.value["holesCount"]);
    this.tournament.teamPlay = this.form.value["teamPlay"];
    //this.tournament.proAm = this.form.value["proAm"];
    this.tournament.proAm = this.form.value["team"] == 2 ? true : false;
    this.tournament.isClosed = this.form.value["isClosed"];
    this.tournament.noOfEnteries = this.form.value["noOfEnteries"];
    this.tournament.scoreTeamPlay = this.tournament.teamPlay;
    this.tournament.isFixtureShow = this.form.value["team"] == 0 ? true : false;
    this.tournament.startDate = this.form.value["startDate"];
    // this.tournament.entriesEndDate = this.form.value["entriesEndDate"];
    this.tournament.isLast3ScoreHide = this.form.value["isLast3ScoreHide"];
    this.tournament.endDate = this.form.value["endDate"];
    this.tournament.startTime = this.form.value["startTime"];

    this.tournament.handicap_percentage = this.form.value[
      "handicap_percentage"
    ];
    // this.tournament.team = this.form.value['team'];
    if (this.tournament.type == 2) {
      this.tournament.leftTeamName = "RED TEAM";
      this.tournament.rightTeamName = "BLUE TEAM";
    }
    if (this.club.type == 1)
    {
      this.tournament.clubName = this.club.name;
    }
    else
    this.tournament.clubName = this.club.name;
    if (this.user.type == 3) {
      this.tournament.isCreatedFromAdmin = true;
    } else {
      this.tournament.isCreatedFromAdmin = false;
    }
    switch (this.user.type) {
      case 1:
        this.tournament.createdBy = 0;
        break;
      case 2:
        this.tournament.createdBy = 5;
        break;
      case 3:
        this.tournament.createdBy = 1;
        break;
      case 5:
        this.tournament.createdBy = 4;
        break;
      case 6:
        this.tournament.createdBy = 2;
        break;
      case 7:
        this.tournament.createdBy = 3;
        break;
    }
    this.tournament.playerPerTeam = this.form.value["playerPerTeam"];
    this.tournament.proGameType = this.form.value["proGameType"];
    this.tournament.team = this.form.value["team"];
    this.tournament.isClosed =
      this.form.value["isClosed"].toLowerCase() === "true" ? true : false;
    this.tournament.code = Math.floor(1000 + Math.random() * 9000);
    this.tournament.isDelete = false;
    this.tournament.isShowOnWebsite = this.form.value["isShowOnWebsite"];
    const startDate = new Date(this.form.value.startDate);
    // const entriesEndDate = new Date(this.form.value.entriesEndDate);
    const sdate = moment(startDate).format("YYYY-MM-DD");
    const sdateTime = moment(
      `${sdate} ${this.form.value.startTime}`,
      "YYYY-MM-DD HH:mm A"
    );

    // const eedate = moment(entriesEndDate).format("YYYY-MM-DD");

    this.tournament.slopeRating = +this.form.value.slop_rating;
    this.tournament.startDate = sdateTime.unix();
    // this.tournament.entriesEndDate = moment(eedate).unix();
    this.tournament.teamPlay = this.tournament.playerPerTeam;
    const edate = moment(startDate).format("YYYY-MM-DD");
    const edateTime = moment(
      `${edate} ${this.tournament.endDate}`,
      "YYYY-MM-DD HH:mm"
    );

    this.tournament.endDate = edateTime.unix();
    this.loading = true;
    let cid = this.club.cid ? this.club.cid : this.club.$key;
    if (this.form.value["type"] == 2) {
      this.tournament.isUnlimitedPlayers = this.form.value[
        "isUnlimitedPlayers"
      ];
      this.tournament.organizerType = this.form.value["organizerType"];
      if (this.form.controls.isUnlimitedPlayers.value == true) {
        // this.form.controls.noOfEnteries.setValue(0);
        this.tournament.noOfEnteries = 0;
      }
    }
    this.tournament.proAm = false;
    if (this.form.controls.team.value == 2) {
      this.tournament.proAm = true;
    }
    this.tournament.createdAt = new Date().getTime() / 1000;
    this.tournament.CMSVersion = environment.version;
    if (this.tournament.cid) {
      let sa = this.tournament.cid.split("-");
      let s = "";
      sa.map((x) => {
        s = s + x;
      });
      this.tournament.es_cid = s;
    }

    this.uploadFile()
      .then((fileResult) => {
        if (fileResult[0] && fileResult[0].downloadURL) {
          this.form.controls["image"].patchValue(fileResult[0].downloadURL);
          this.tournament.image = fileResult[0].downloadURL;
        }
        if (fileResult[1] && fileResult[1].downloadURL) {
          this.form.controls["originalImage"].patchValue(
            fileResult[1].downloadURL
          );
          this.tournament.originalImage = fileResult[1].downloadURL;
        }

        this.apiService
          .object(
            "/courses/" +
              cid +
              "/" +
              this.course.$key +
              "/" +
              this.form.get("tee").value
          )
          .then((response) => {
            const key = this.fireDatabase.database.ref(`/tournaments`).push()
              .key;
            let updates = {};
            updates["/tournaments/" + key] = this.tournament;
            updates["/tournaments-course/" + key] = response;

            if (!this.tournament.isClosed) {
              updates[`/server-process/add-tournament/${cid}/${key}`] = 1;
            }
            updates[
              `tee-slope-ratings/${this.form.value.cid}/${this.form.value.course}/${this.form.value.tee}/verifiedSlopRating`
            ] = +this.form.value.slop_rating;
            updates[
              `tee-slope-ratings/${this.form.value.cid}/${this.form.value.course}/${this.form.value.tee}/verifiedSlopeRatingDate`
            ] = new Date().getTime() / 1000;
            updates["golf-tournaments/" + this.user.cid + "/" + key] = parseInt(
              new Date(this.minTill).getTime() / 1000 + ""
            );
            if (this.tournament.mapWithEvent == 1) {
              updates[
                `user-offers/${this.tournament.offerOwnerId}/${this.tournament.offerId}/validTill`
              ] = this.datePipe.transform(sdateTime, "yyyy-MM-dd");
            }
            return this.apiService.bulkUpdate(updates);
          })
          .catch((error) => {
            console.error(error);

            alert("Sorry, something went wrong!");
            this.loading = false;
          });
      })
      .then(() => {
        setTimeout(() => {
          return this.router.navigate(["/components/tournaments"]);
        }, 2000);
      })
      .catch((error) => {
        this.error(error);
      });
  }

  public onScoreTeamPlayChange(event) {
    let o = event;
  }

  private error(error): void {
    console.error(error);
    alert("Sorry, something went wrong!");

    this.loading = false;
  }

  onUnlimitedPlayersClick(event) {
    if (this.form.controls.isUnlimitedPlayers.value == true) {
      this.form.controls.noOfEnteries.disable({ onlySelf: true });
    } else {
      this.form.controls.noOfEnteries.enable({ onlySelf: true });
    }
  }

  handleTypeChange(event) {
    if (this.form.controls.type.value != 2) {
      this.form.controls.noOfEnteries.enable({ onlySelf: true });
    } else {
      this.onUnlimitedPlayersClick(null);
    }
  }

  async getDefaultList() {
    try {
      if (this.user.type == 3 && this.user.role == 1) {
        let result: any = await this.apiService.object("/index/offers");
        let offersByOwner: any = {};
        if (result) {
          for (let key in result) {
            let newkey = result[key];
            if (offersByOwner[newkey]) {
              offersByOwner[newkey] = [...offersByOwner[newkey], key];
            } else {
              offersByOwner[newkey] = [key];
            }
          }
          if (offersByOwner) {
            for (let key in offersByOwner) {
              for (let index = 0; index < offersByOwner[key].length; index++) {
                const element = offersByOwner[key][index];
                let offer: any = await this.apiService.object(
                  `/user-offers/${key}/${element}`
                );
                if (
                  offer["status"] == 1 &&
                  offer["offerType"] == 3 &&
                  !offer["tournamentId"]
                ) {
                  let map = {
                    ...offer,
                    owner: key,
                    key: element,
                  };
                  this.events.push(map);
                }
              }
            }
          }
        }
      } else {
        let data = await this.apiService.object("user-offers/" + this.user.cid);
        if (data) {
          for (let key in data) {
            let event: any = data[key];
            event["key"] = key;
            if (event["status"] == 1 && event["offerType"] == 3) {
              this.events.push(event);
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}
